import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { applyRouterMiddleware, Router } from 'react-router';
import useScroll from 'react-router-scroll/lib/useScroll';

import BowserProvider from 'utils/BowserProvider';

import App from 'apps/app/components/App';
import ErrorBoundary from 'utils/components/ErrorBoundary';
import routes from 'routes';

export { routes };

const REDIAL_CONFIG = {
  blocking: ['fetch'], // hooks that must be triggered before transition to the next route/component (2nd and onwards)
  deferred: [['defer'], ['done']], // hooks to trigger after transition to route/component completed (async data loading)
  cleanup: ['cleanup'], // hooks to be triggered on old (i.e. no longer active) routes after the transition completed}
};

const Root = ({ store, renderProps }) => (
  <BowserProvider>
    <Provider store={store}>
      <Router
        {...renderProps}
        render={props => (
          <ErrorBoundary>
            <App
              {...props}
              redialConfig={REDIAL_CONFIG}
              redialConfigStore={store}
              render={applyRouterMiddleware(useScroll())} // eslint-disable-line react-hooks/rules-of-hooks
              stateSupplier={store.getState}
            />
          </ErrorBoundary>
        )}
      />
    </Provider>
  </BowserProvider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
  renderProps: PropTypes.shape({
    location: PropTypes.object,
  }),
};

export default Root;
